import { render } from "./receipt.vue?vue&type=template&id=2d5141fc"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"

import "./receipt.vue?vue&type=style&index=0&id=2d5141fc&lang=scss"
script.render = render

export default script